import { CircularProgress } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useMutation } from "@tanstack/react-query";
import { getTransactionHistoryCentralWarehouse } from "../../../../services/centralWarehouseApi";

const toIDR = (val) =>
  val?.toLocaleString("id-ID", {
    style: "currency",
    currency: "IDR",
  });

const TransactionHistory = ({ title, type, outlet }) => {
  const [offsetHistory, setOffsetHistory] = useState(1);

  const {
    mutate: mutateHistory,
    data: dataHistory,
    isLoading: isLoadingHistory,
  } = useMutation({
    mutationFn: getTransactionHistoryCentralWarehouse,
  });

  useEffect(() => {
    if (type && outlet) {
      mutateHistory({
        company_id: outlet,
        type: type,
        offset: offsetHistory,
        limit: 1,
      });
    }
  }, [type, outlet, offsetHistory]);

  return (
    <div className="border-2 rounded-md p-3 h-full">
      <p className="font-bold mb-2 text-[14px]">{title}</p>
      <div className="flex justify-end w-full mb-2">
        <div className="flex gap-4 justify-between items-center w-3/4">
          <button
            type="button"
            className="border rounded-md p-1 disabled:bg-gray-300 disabled:text-white w-[32px] h-[32px] flex items-center justify-center"
            disabled={
              offsetHistory === 1 || !dataHistory || isLoadingHistory || !type
            }
            onClick={() => setOffsetHistory(offsetHistory - 1)}
          >
            <FaChevronLeft />
          </button>
          <p>
            {dataHistory && dataHistory.request && type ? (
              <>
                {moment(dataHistory.request[0]?.updated_at).format(
                  "DD MMMM YYYY"
                )}
              </>
            ) : (
              "-"
            )}
          </p>
          <button
            type="button"
            className="border rounded-md p-1 disabled:bg-gray-300 disabled:text-white w-[32px] h-[32px] flex items-center justify-center"
            disabled={
              (dataHistory && offsetHistory === dataHistory.count) ||
              !dataHistory ||
              isLoadingHistory ||
              !type
            }
            onClick={() => setOffsetHistory(offsetHistory + 1)}
          >
            <FaChevronRight />
          </button>
        </div>
      </div>
      <hr className="my-2" />
      {type && dataHistory && !isLoadingHistory && dataHistory.request ? (
        <>
          <div className="mb-2">
            <div className="w-full flex gap-2 items-center">
              <p className="w-1/3">ID Transaksi</p>
              <p>:</p>
              <p>{dataHistory.request[0]?.transaction_number}</p>
            </div>
            <div className="w-full flex gap-2 items-center">
              <p className="w-1/3">Tanggal</p>
              <p>:</p>
              <p>
                {moment(dataHistory.request[0]?.date).format("DD MMMM YYYY")}
              </p>
            </div>
            <div className="w-full flex gap-2 items-center">
              <p className="w-1/3">User</p>
              <p>:</p>
              <p>{dataHistory.request[0]?.created_by}</p>
            </div>
            <div className="w-full flex gap-2 items-center">
              <p className="w-1/3">Status Bayar</p>
              <p>:</p>
              <p>
                {dataHistory.request[0]?.is_paid ? "Lunas" : "Belum Dibayar"}
              </p>
            </div>
            <div className="w-full flex gap-2 items-center">
              <p className="w-1/3">Status</p>
              <p>:</p>
              <p>
                {dataHistory.request[0]?.status === 1
                  ? "In Progress"
                  : dataHistory.request[0]?.status === 2 ||
                    dataHistory.request[0]?.status === 4
                  ? "Accepted"
                  : "Rejected"}
              </p>
            </div>
            <div className="w-full flex gap-2 items-center">
              <p className="w-1/3">Tanggal Diterima</p>
              <p>:</p>
              <p>
                {moment(dataHistory.request[0]?.updated_at).format(
                  "DD MMMM YYYY"
                )}
              </p>
            </div>
          </div>

          <div className="max-h-[45vh] overflow-y-auto w-full bg-gray-100 rounded-md p-3 mb-4">
            {dataHistory.request[0]?.product.map((item, i) => (
              <div
                className={`bg-white rounded-md py-2 px-4 ${
                  i === dataHistory.request[0]?.product.length - 1 ? "" : "mb-3"
                }`}
                key={i}
              >
                <div className="mb-2">
                  <div className="w-full flex gap-2">
                    <p className="w-full">Nama Produk</p>
                    <p className="w-full">HNA</p>
                  </div>
                  <div className="w-full flex gap-2 text-[14px] font-bold">
                    <p className="w-full">{item.product_name}</p>
                    <p className="w-full">{toIDR(item.pharmacy_net_price)}</p>
                  </div>
                </div>
                <div className="mb-2">
                  <div className="w-full flex gap-2">
                    <p className="w-full">Kuantitas Diterima</p>
                    <p className="w-full">Diskon</p>
                  </div>
                  <div className="w-full flex gap-2 text-[14px] font-bold">
                    <p className="w-full">{item.quantity_received}</p>
                    <p className="w-full">
                      {item.pharmacy_net_price_discount}%
                    </p>
                  </div>
                </div>
                <div className="mb-2">
                  <div className="w-full flex gap-2">
                    <p className="w-full">Batch</p>
                    <p className="w-full">PPN</p>
                  </div>
                  <div className="w-full flex gap-2 text-[14px] font-bold">
                    <p className="w-full">{item.batch}</p>
                    <p className="w-full">
                      {item.pharmacy_net_price_ppn_value * 100}%
                    </p>
                  </div>
                </div>
                <div className="mb-2">
                  <div className="w-full flex gap-2">
                    <p className="w-full">Final Price</p>
                    <p className="w-full">Total</p>
                  </div>
                  <div className="w-full flex gap-2 text-[14px] font-bold">
                    <p className="w-full">{toIDR(item.hna)}</p>
                    <p className="w-full">
                      {toIDR(item.hna * item.quantity_received)}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className="h-full min-h-[55vh] flex items-center justify-center text-gray-400 text-center w-full">
          {isLoadingHistory ? (
            <CircularProgress size={20} />
          ) : (
            <>
              Silahkan tambahkan outlet <br />
              terlebih dahulu untuk melihat riwayat
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default TransactionHistory;
